import { Link } from 'react-router';
import { Activity, Calendar } from 'lucide-react';
import { Card, CardBody } from '@/components/ui/Card';
import { Avatar } from '@/components/ui/Avatar';
import { StatusBadge } from '@/components/ui/Badge';
import { getPatientFullName, getPatientInitials, type Patient } from '@/types/patient';

interface PatientCardProps {
  patient: Patient;
}

export function PatientCard({
  patient,
}: PatientCardProps) {
  const fullName = getPatientFullName(patient);
  const initials = getPatientInitials(patient);

  return (
    <Card className="transition-all hover:shadow-card-hover">
      <CardBody>
        <div className="flex items-start gap-4">
          <Avatar initials={initials} size="lg" />

          <div className="min-w-0 flex-1">
            <div className="flex items-start justify-between gap-2">
              <div>
                <Link
                  to={`/doctor/patients/${patient.id}`}
                  className="font-semibold text-foreground hover:text-primary"
                >
                  {fullName}
                </Link>
                <p className="text-sm text-muted">{patient.username}</p>
              </div>
              <StatusBadge status={patient.status} />
            </div>

            <div className="mt-3 flex flex-wrap items-center gap-4 text-sm text-muted">
              <div className="flex items-center gap-1">
                <Activity className="h-4 w-4" />
                <span>{patient.totalActivities} activities</span>
              </div>
              {patient.dateOfBirth && (
                <div className="flex items-center gap-1">
                  <Calendar className="h-4 w-4" />
                  <span>DOB: {patient.dateOfBirth}</span>
                </div>
              )}
            </div>
          </div>
        </div>
      </CardBody>
    </Card>
  );
}
